<template>
  <div class="header" :style="{ background: `url(${item.display_img_url})` }">
    <div
      class="header-name"
      :class="namespaceGroupEn"
      v-if="pageConfig.headerName"
    >
      {{ pageConfig.headerName }}
    </div>
    <div class="expiry-date" :class="{ lr: isLr }" v-if="isMember">
      到期时间：{{ card.card_expiry_date }}
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  defineComponent,
  onMounted,
  ref,
  computed,
} from "@vue/composition-api";

import { useStore } from "@/components/use/base";
import { jsonSafeParse } from "@/utils";

const vm = Vue.prototype;

export default defineComponent({
  name: "BjHeader",
  props: ["item", "card"],
  setup() {
    const store = useStore();

    const namespace = computed(() => store.state.namespace);
    const isMember = computed(() => store.state.isMember);

    const namespaceGroupEn = computed(() => {
      return store.state.namespaceInfo?.namespace_group_en || "";
    });

    const isLr = computed(() => {
      return namespace.value.startsWith("lr");
    });

    const pageConfig = ref({});
    onMounted(() => {
      pageConfig.value = jsonSafeParse(vm.$getConfigValue("BJ_CARD_MAP"))[
        namespace.value
      ];
    });

    return { pageConfig, isLr, namespaceGroupEn, isMember };
  },
});
</script>

<style lang="less" scoped>
.header {
  height: 230px;
  width: 100%;
  background-repeat: no-repeat !important;
  background-size: 100% !important;
  z-index: 0;
  position: relative;
  margin-bottom: -32px;

  .header-name {
    font-size: 24px;
    position: absolute;
    left: 49px;
    top: 85px;
    color: #dfc8b4;
    &.lianrong {
      font-family: "YouSheBiaoTiHei-2";
    }
  }

  .expiry-date {
    position: absolute;
    top: 145px;
    left: 49px;
    color: #4a5f77;
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;

    &.lr {
      color: #e0c7b3;
      top: 120px;
    }
  }
}
</style>
